import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { PageSection, Row, Cell, Divider, LeftRail, RightRail } from 'sarsaparilla';
import { LoadingWrapper } from '../../../ui-lottery';
import { FacilityProps, PassTypeProps, ReservationProps } from '../props';
import RenderIf from '../utils/JSXUtils';
import PageRegion from './layout/PageRegion';
import FacilitySelect from './FacilitySelect';
import PassTypesTable from './PassTypesTable';
import PassInfoForm from './PassInfoForm';
import ReservationSummary from './ReservationSummary';

const propTypes = {
  facilityId: PropTypes.string,
  facilities: PropTypes.arrayOf(FacilityProps),
  passTypeId: PropTypes.string,
  passTypes: PropTypes.arrayOf(PassTypeProps),
  reservation: ReservationProps.isRequired,
  loading: PropTypes.objectOf(PropTypes.bool),
  loaded: PropTypes.objectOf(PropTypes.bool),
  onFacilityChange: PropTypes.func.isRequired,
  onPassTypeChange: PropTypes.func.isRequired,
  onReservationChange: PropTypes.func.isRequired,
  children: PropTypes.node
};

export default class OrderDetails extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false
    };

    this.onPassInfoChanged = this.onPassInfoChanged.bind(this);
  }

  onPassInfoChanged(passInfo, isValid) {
    this.setState((prevState) => ({ ...prevState, isValid }), () => {
      this.props.onReservationChange({ pass_info: passInfo }, this.state.isValid);
    });
  }

  render() {
    const { facilities, facilityId, passTypes, passTypeId, reservation, loading, loaded, children } = this.props;
    const passType = passTypes.find((pt) => pt.id === passTypeId);

    return (
      <PageSection>
        <Row>
          <Cell>
            <h2>Order Details</h2>
          </Cell>
          <LeftRail>
            <LoadingWrapper loading={loading.facilities} size={'large'}>
              <PageRegion>
                <Row>
                  <Cell>
                    <h4 className="parkpass-section-heading">Pass Information</h4>
                    <FacilitySelect
                      onChange={this.props.onFacilityChange}
                      facilities={facilities}
                      facilityId={facilityId} />
                  </Cell>
                </Row>
              </PageRegion>
            </LoadingWrapper>
            {RenderIf(loading.passTypes || loaded.passTypes)(
              <LoadingWrapper loading={loading.passTypes} size={'large'}>
                <PageRegion>
                  <Row>
                    <Cell>
                      <PassTypesTable
                        passTypes={passTypes}
                        selected={passTypeId}
                        onChange={this.props.onPassTypeChange} />
                    </Cell>
                  </Row>
                </PageRegion>
              </LoadingWrapper>
            )}
            <Divider />
            <Row>
              <Cell>
                {RenderIf(!!passType)(() => <PassInfoForm
                  passType={passType}
                  passInfo={reservation.pass_info}
                  onChange={this.onPassInfoChanged} />)}
              </Cell>
            </Row>
          </LeftRail>

          <RightRail>
            {RenderIf(!!passType)(() => <ReservationSummary
              passType={passType}
              reservation={reservation}>
              {children}
            </ReservationSummary>)}
          </RightRail>
        </Row>
      </PageSection>
    );
  }
}

OrderDetails.propTypes = propTypes;
